import React, { useState } from "react";

import { cn } from "utils";
import AppDialog from "components/AppDialog";
import { Button } from "components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import JobAssessmentsTab from "./JobAssessmentsTab";
import CandidateAssessmentsTab from "./CandidateAssessmentsTab";

// Two-tab dialog for a job's assessments:
//  - "Job Assessments": manage the assessments assigned to the job (wizard).
//  - "Candidate Assessments": review the assessments candidates have taken.
// Each tab is self-contained and fetches its own data when it mounts. The
// dialog never exceeds the viewport; the Candidate Assessments tab shows more
// columns, so the dialog widens when it is active.
const DEFAULT_TAB = "job";

// Width per tab. Assessment Results carries seven mostly non-wrapping columns
// and its last one ("View Result") is the point of the tab, so at the narrower
// wizard width the table scrolled horizontally and hid it. Both widths stay
// inside the viewport; 1200px matches the app's other wide table dialogs.
const DIALOG_WIDTH_BY_TAB = {
  job: "w-full max-w-[780px]",
  candidate: "w-[92vw] max-w-[1200px]",
};

const RopesAssessmentDialog = () => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(DEFAULT_TAB);

  // Always go through this for open/close so reopen cannot leave a leftover tab.
  // The trigger used to call setOpen(true) only, so Assessment Results stayed selected.
  const handleOpenChange = (nextOpen) => {
    setOpen(nextOpen);
    if (nextOpen) {
      setTab(DEFAULT_TAB);
    }
  };

  return (
    <>
      <Button variant="outline" onClick={() => handleOpenChange(true)}>
        View Assessments
      </Button>

      <AppDialog
        open={open}
        onOpenChange={handleOpenChange}
        header="Job Assessments"
        className={cn(
          "flex max-h-[90vh] flex-col",
          DIALOG_WIDTH_BY_TAB[tab] || DIALOG_WIDTH_BY_TAB[DEFAULT_TAB]
        )}
        contentClassName="flex min-h-0 flex-1 flex-col p-6"
      >
        <Tabs
          value={tab}
          onValueChange={setTab}
          className="flex min-h-0 flex-1 flex-col"
        >
          <TabsList className="w-fit shrink-0">
            <TabsTrigger value="candidate" className="gap-x-2">
              Assessment Results
            </TabsTrigger>
            <TabsTrigger value="job" className="gap-x-2">
              Add/Remove Assessments
            </TabsTrigger>
          </TabsList>

          <TabsContent value="job" className="flex min-h-0 flex-1 flex-col">
            <JobAssessmentsTab onClose={() => handleOpenChange(false)} />
          </TabsContent>

          <TabsContent
            value="candidate"
            className="flex min-h-0 flex-1 flex-col"
          >
            <CandidateAssessmentsTab />
          </TabsContent>
        </Tabs>
      </AppDialog>
    </>
  );
};

export default RopesAssessmentDialog;
